import React from "react";
import { Box, Typography, Button } from "@mui/material";
import cutButton from "../Icons/Group 144.png";
import "../Investor/style/RescheduleMeetingReason.css";

const RescheduleMeetingReason = ({ handleClose, handleNext, handleChange, res, cancelMeeting }) => {
    return (
        <Box className="Frame427319323">
            <Box className="Frame427319561">
                <Box className="Frame427319556">
                    <Box className="Frame427319502">
                        <Typography className="reschedule-heading">{!res ? "Reschedule Meeting" : "Cancel Meeting"}</Typography>
                    </Box>
                    <Button onClick={handleClose}>
                        <img src={cutButton} alt="X" />
                    </Button>
                </Box>
                <Box className="main-input">
                    <Box className="label">
                        <Typography className="reason-heading">{!res ? "Reschedule Reason" : "Cancel Reason"}</Typography>
                        <Typography className="star">*</Typography>
                    </Box>
                    <Box className="input">
                        <Box className="inside-input-box">
                            <textarea name="reason" placeholder="Enter Reason" onChange={handleChange} className="text-area"></textarea>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box className="Frame427319560">
                <Button onClick={handleClose} className="resch-btn">
                    <Typography className="resch-btn-text">Cancel</Typography>
                </Button>
                <Button onClick={!res ? handleNext : cancelMeeting} sx={{ backgroundColor: "white", '&:hover': {backgroundColor: "lightcoral"}, minWidth: "137px" }} className="resch-btn">
                    <Typography sx={{ color: "black" }} className="resch-btn-text">{!res ? "Next" : "Cancel Meeting"}</Typography>
                </Button>
            </Box>
        </Box>
    )
}

export default RescheduleMeetingReason;